// import React, { useState } from "react";
// import { Box, Container, Grid, Typography } from "@mui/material";
// import AnimatedSection from "../common/AnimatedSection";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7"; const ORANGE = "#FF9F1C";

// const BORDER_COLORS = [CORAL, TEAL, PURPLE, YELLOW, ORANGE, "#74C0FC"];

// const REAL_IMAGES = [
//   { src: "/illustrations/classroom-learning.png", title: "Smart Classrooms" },
//   { src: "/illustrations/faculty-guidance.png",   title: "Expert Faculty" },
//   { src: "/illustrations/art-activity.png",        title: "Creative Arts" },
//   { src: "/illustrations/reading-library.png",     title: "Reading Zone" },
//   { src: "/illustrations/sports-activity.png",     title: "Sports & Play" },
//   { src: "/illustrations/school-campus.png",       title: "Our Campus" },
// ];

// const GallerySection = ({ images }) => {
//   const [hovered, setHovered] = useState(null);

//   return (
//     <AnimatedSection id="gallery" sx={{ backgroundColor: NAVY, py: { xs: 9, md: 12 } }}>
//       <Container maxWidth="xl">
//         <Box sx={{ textAlign: "center", mb: 6 }}>
//           <Box sx={{ display: "inline-block", px: 2, py: 0.5, mb: 2, borderRadius: "8px", border: `2px solid ${YELLOW}`, backgroundColor: "rgba(255,211,61,0.12)", fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.78rem", letterSpacing: "0.1em", color: YELLOW, textTransform: "uppercase" }}>
//             Gallery
//           </Box>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: { xs: "2rem", md: "2.8rem" }, color: "#FFF8F0" }}>
//             Snapshots of Joyful Learning 📷
//           </Typography>
//         </Box>

//         <Grid container spacing={2.5}>
//           {REAL_IMAGES.map((img, i) => (
//             <Grid item xs={12} sm={6} md={4} key={i}>
//               <Box
//                 onMouseEnter={() => setHovered(i)}
//                 onMouseLeave={() => setHovered(null)}
//                 sx={{
//                   position: "relative",
//                   borderRadius: "16px",
//                   border: `3px solid ${BORDER_COLORS[i]}`,
//                   boxShadow: hovered === i ? `8px 8px 0 ${BORDER_COLORS[i]}` : `5px 5px 0 ${BORDER_COLORS[i]}`,
//                   overflow: "hidden",
//                   cursor: "pointer",
//                   transform: hovered === i ? "translate(-3px,-3px) scale(1.01)" : "none",
//                   transition: "all 0.25s ease",
//                   aspectRatio: "4/3",
//                   backgroundColor: "#111",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={img.src}
//                   alt={img.title}
//                   sx={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.4s ease", transform: hovered === i ? "scale(1.05)" : "scale(1)" }}
//                 />
//                 {/* Overlay */}
//                 <Box sx={{ position: "absolute", inset: 0, backgroundColor: hovered === i ? "rgba(27,31,59,0.6)" : "rgba(27,31,59,0)", transition: "background-color 0.3s ease", display: "flex", alignItems: "flex-end", p: 2 }}>
//                   <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.1rem", color: BORDER_COLORS[i], opacity: hovered === i ? 1 : 0, transition: "opacity 0.3s ease", textShadow: "0 2px 8px rgba(0,0,0,0.5)" }}>
//                     {img.title}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>
//     </AnimatedSection>
//   );
// };

// export default GallerySection;













import React, { useState } from "react";
import { Box, Container, Grid, Typography, Chip } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const PURPLE = "#845EF7";
const ORANGE = "#FF9F1C";
const CREAM = "#FFF8F0";

const BORDER_COLORS = [CORAL, TEAL, PURPLE, YELLOW, ORANGE, "#74C0FC"];
const BADGE_COLORS = ["🎨", "👩‍🏫", "🎭", "📚", "⚽", "🏫"];
const OVERLAY_COLORS = [CORAL, TEAL, PURPLE, YELLOW, ORANGE, "#74C0FC"];

const REAL_IMAGES = [
  { src: "/gallery-sec/classroom-learning.png", title: "Smart Classrooms", badge: "Tech" },
  { src: "/gallery-sec/faculty-guidance.png", title: "Expert Faculty", badge: "Mentors" },
  { src: "/gallery-sec/art-activity.png", title: "Creative Arts", badge: "Create" },
  { src: "/gallery-sec/reading-library.png", title: "Reading Zone", badge: "Read" },
  { src: "/gallery-sec/sports-activity.png", title: "Sports & Play", badge: "Play" },
  { src: "/gallery-sec/school-campus.png", title: "Our Campus", badge: "Explore" },
];

const GallerySection = ({ images }) => {
  const [hovered, setHovered] = useState(null);

  return (
    <AnimatedSection id="gallery" sx={{ backgroundColor: CREAM, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
      {/* Decorative background elements */}
      <Box sx={{ position: "absolute", top: -50, left: -50, width: 180, height: 180, borderRadius: "50%", backgroundColor: CORAL, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
      <Box sx={{ position: "absolute", bottom: -40, right: -40, width: 220, height: 220, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
      <Box sx={{ position: "absolute", top: "30%", right: "5%", fontSize: "45px", opacity: 0.06, animation: "floatY 4s ease-in-out infinite" }}>📸</Box>
      <Box sx={{ position: "absolute", bottom: "20%", left: "5%", fontSize: "35px", opacity: 0.06, animation: "floatY 3s ease-in-out infinite" }}>✨</Box>

      <Container maxWidth="xl" sx={{ position: "relative" }}>
        <SectionHeading
          eyebrow="Gallery"
          title="Moments That Make School Special 📷"
          description="See the joyful moments of learning, activities, celebrations and everyday life at our school."
          align="center"
          eyebrowColor={CORAL}
          eyebrowBg="#FFE8E8"
        />

        <Grid container spacing={2.5}>
          {REAL_IMAGES.map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                sx={{
                  position: "relative",
                  borderRadius: "20px",
                  border: `3px solid ${NAVY}`,
                  boxShadow: hovered === i
                    ? `8px 8px 0 ${BORDER_COLORS[i]}`
                    : `5px 5px 0 ${NAVY}`,
                  overflow: "hidden",
                  cursor: "pointer",
                  transform: hovered === i ? "translate(-3px,-3px)" : "none",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  aspectRatio: "4/3",
                  backgroundColor: "#FFF0E0",
                }}
              >
                {/* Image */}
                <Box
                  component="img"
                  src={img.src}
                  alt={img.title}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                    transform: hovered === i ? "scale(1.08)" : "scale(1)",
                  }}
                />

                {/* Colored accent border on hover */}
                <Box sx={{
                  position: "absolute",
                  inset: 0,
                  border: `3px solid ${BORDER_COLORS[i]}`,
                  borderRadius: "17px",
                  opacity: hovered === i ? 1 : 0,
                  transition: "opacity 0.3s ease",
                  pointerEvents: "none",
                }} />

                {/* Top badge */}
                <Box sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  border: `2px solid ${NAVY}`,
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 800,
                  fontSize: "0.7rem",
                  color: BORDER_COLORS[i],
                  boxShadow: `2px 2px 0 ${NAVY}`,
                  transform: hovered === i ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.3s ease",
                  opacity: hovered === i ? 1 : 0.85,
                }}>
                  {img.badge}
                </Box>

                {/* Overlay with title */}
                <Box sx={{
                  position: "absolute",
                  inset: 0,
                  background: hovered === i
                    ? `linear-gradient(to top, ${OVERLAY_COLORS[i]}DD 0%, ${OVERLAY_COLORS[i]}44 40%, transparent 100%)`
                    : "linear-gradient(to top, rgba(27,31,59,0.3) 0%, transparent 50%)",
                  transition: "all 0.4s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: 2.5,
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                    <Typography sx={{
                      fontSize: "1.3rem",
                      opacity: hovered === i ? 1 : 0.7,
                      transition: "opacity 0.3s ease",
                    }}>
                      {BADGE_COLORS[i]}
                    </Typography>
                    <Typography sx={{
                      fontFamily: "'Fredoka One', cursive",
                      fontSize: hovered === i ? "1.3rem" : "1.05rem",
                      color: "#fff",
                      textShadow: "0 2px 8px rgba(0,0,0,0.4)",
                      transition: "all 0.3s ease",
                      fontWeight: 600,
                    }}>
                      {img.title}
                    </Typography>
                  </Box>
                  {hovered === i && (
                    <Typography sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontSize: "0.8rem",
                      color: "#fff",
                      opacity: 0.9,
                      fontWeight: 600,
                      textShadow: "0 1px 4px rgba(0,0,0,0.3)",
                      animation: "fadeInUp 0.3s ease",
                    }}>
                      Click to explore →
                    </Typography>
                  )}
                </Box>

                {/* Shine effect on hover */}
                <Box sx={{
                  position: "absolute",
                  top: 0,
                  left: "-100%",
                  width: "50%",
                  height: "100%",
                  background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                  transform: hovered === i ? "translateX(300%)" : "translateX(0)",
                  transition: "transform 0.6s ease",
                }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </AnimatedSection>
  );
};

export default GallerySection;
